export enum ItemType {
  CHAIR,
  COMPUTER,
  WHITEBOARD,
  VENDINGMACHINE,
  MICROBIOLOGIST,
  SPECIMENDEALER,
  TOKENTRADER,
}
